const createHistory = require("history").createBrowserHistory;
export default createHistory({basename: process.env.PUBLIC_URL});

// export default createHistory();
